module.exports = __webpack_public_path__ + "img/1-1.72bd38a0.svg";